/**
 * Flip one card to submitted in local message state.
 *
 * The card component tracks its own pending/submitted state, but the composer
 * lock reads `blocks` off the thread — so without this the form goes read-only
 * while the composer stays locked until the next reload.
 */
export function markClarificationSubmitted(messagesByThreadId, { tid, assistantMessageId, answers }) {
  const messages = messagesByThreadId[tid]
  if (!Array.isArray(messages)) return messagesByThreadId
  let changed = false
  const next = messages.map((message) => {
    if (message.role !== 'assistant' || !Array.isArray(message.blocks)) return message
    const blocks = message.blocks.map((block) => {
      if (block?.type !== 'clarification_card') return block
      if (block.assistant_message_id !== assistantMessageId) return block
      if (block.status === 'submitted') return block
      changed = true
      return { ...block, status: 'submitted', submitted_answers: { ...answers } }
    })
    return changed ? { ...message, blocks } : message
  })
  return changed ? { ...messagesByThreadId, [tid]: next } : messagesByThreadId
}
